
import Vue from 'vue';
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { DeviceType, Breakpoint, Orientation, Zoom } from '@/types/editor';

@Component
export default class ContentPreview extends Vue {
  @Prop() value!: boolean;
  @Prop() id!: string;
  @Prop({ default: '' })
  type!: string;
  @Prop({ default: 'latest' })
  commit!: string;
  @State('baseUrl') baseUrl!: string;

  breakpoints: Record<DeviceType, Breakpoint> = {
    phone: { width: 414, height: 736, zoom: 1, rotatable: true },
    tablet: { width: 768, height: 1024, zoom: 1, rotatable: true },
    laptop: { width: 1280, height: 800, zoom: 1, rotatable: false },
    desktop: { width: 1920, height: 1080, zoom: 1, rotatable: false },
  };

  activeBreakpoint: DeviceType = DeviceType.Desktop;
  orientation: Orientation = Orientation.Portrait;
  zoom: Zoom = Zoom.Full;
  zoomOptions = [
    { text: '200%', value: Zoom.Double },
    { text: '150%', value: Zoom.OneAndAHalf },
    { text: '100%', value: Zoom.Full },
    { text: '75%', value: Zoom.ThreeQuaters },
    { text: '50%', value: Zoom.Half },
  ];

  get breakpoint(): Breakpoint {
    return this.breakpoints[this.activeBreakpoint];
  }

  get iframeWidth(): string {
    return this.breakpoint.rotatable &&
      this.orientation === Orientation.Landscape
      ? `${this.breakpoint.height}px`
      : `${this.breakpoint.width}px`;
  }

  get iframeHeight(): string {
    return this.breakpoint.rotatable &&
      this.orientation === Orientation.Landscape
      ? `${this.breakpoint.width}px`
      : `${this.breakpoint.height}px`;
  }

  get rotatable(): boolean {
    return this.breakpoint.rotatable;
  }

  get iFrameSrc(): string {
    const route = `${this.type}/preview`;
    const qs = this.commit !== 'latest' ? `?commit=${this.commit}` : '';
    return this.id ? `${this.baseUrl}/${route}/${this.id}${qs}` : 'about:blank';
  }

  @Emit('input')
  closeDialog(): boolean {
    return false;
  }

  @Watch('value')
  onValueChanged(val: boolean) {
    if (val) {
      const iframe = document.getElementById(
        'iFramePreview',
      ) as HTMLIFrameElement;
      if (iframe) {
        iframe.src = this.iFrameSrc;
      }
    }
  }

  @Watch('zoom')
  onZoomChanged(val: number) {
    const iframe = document.getElementById(
      'iFramePreview',
    ) as HTMLIFrameElement;
    if (iframe) {
      iframe.style.transform = `scale(${val})`;
    }
  }
}
